export default class ImageBlock {
 constructor({ data }) {
    // Wenn kein src vorhanden oder leer: Standard-URL setzen
    const defaultSrc = "https://www.denisbitter.de/images/";
    this.data = {
      src: data?.src?.trim() || defaultSrc,
      alt: data?.alt || "",
    };
    this.wrapper = null;
  }

  render() {
    this.wrapper = document.createElement("div");
    this.wrapper.className = "editorjs-image space-y-2"; // optionale Klasse für zusätzliche Kontrolle

    const urlInput = document.createElement("input");
    urlInput.placeholder = "Bild-URL";
    urlInput.value = this.data.src;
    urlInput.className = "w-full border p-2 rounded";

    const altInput = document.createElement("input");
    altInput.placeholder = "Alt-Text";
    altInput.value = this.data.alt;
    altInput.className = "w-full border p-2 rounded";

    const preview = document.createElement("img");
    preview.src = this.data.src;
    preview.alt = this.data.alt;

    // WICHTIG: responsive & begrenzt in Größe
    preview.className = "w-full max-w-[600px] mx-auto mt-2 rounded shadow";

    urlInput.addEventListener("input", (e) => {
      this.data.src = e.target.value;
      preview.src = e.target.value;
    });

    altInput.addEventListener("input", (e) => {
      this.data.alt = e.target.value;
      preview.alt = e.target.value;
    });

    this.wrapper.appendChild(urlInput);
    this.wrapper.appendChild(altInput);
    this.wrapper.appendChild(preview);

    return this.wrapper;
  }

  save() {
    return this.data;
  }

  static get toolbox() {
    return {
      title: "Image",
      icon: "🖼️",
    };
  }
}
